function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .premium-cls-1{fill:#ffe400}.premium-cls-2{fill:#b2dcbb}.premium-cls-3{fill:#fff}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_249",
  d: "M64.262 39.831a18.331 18.331 0 1 0-18.331 18.332 18.323 18.323 0 0 0 18.331-18.332",
  className: "premium-cls-1",
  "data-name": "Path 249",
  transform: "translate(-10.314 -21.5)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_250",
  d: "M72.259 41.576A18.287 18.287 0 0 1 68.4 52.751h21.145L78.37 41.576 89.545 30.4H68.4a18.287 18.287 0 0 1 3.859 11.176",
  className: "premium-cls-2",
  "data-name": "Path 250",
  transform: "translate(-18.311 -23.244)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_251",
  d: "M47.421 27.9l3.94 7.879 8.281 1.286-5.869 6.11 1.769 8.12-8.12-3.538L39.3 51.3l1.849-8.12-5.95-6.11 8.362-1.286z",
  className: "premium-cls-3",
  "data-name": "Path 251",
  transform: "translate(-11.804 -22.754)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_252",
  d: "M23.386 41.576A18.287 18.287 0 0 1 27.245 30.4H6.1l11.176 11.176L6.1 52.751h21.145a17.947 17.947 0 0 1-3.859-11.176",
  className: "premium-cls-2",
  "data-name": "Path 252",
  transform: "translate(-6.1 -23.244)"
});

var SvgPremium = function SvgPremium(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Premium",
    width: 71.234,
    height: 36.663,
    viewBox: "0 0 71.234 36.663",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPremium, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Premium.431f822d.svg";
export { ForwardRef as ReactComponent };